import { Typography } from '@one-thd/sui-atomic-components';
import React from 'react';
export var PartsAndServices = function (_a) {
    var items = _a.items;
    var priceFormatter = function (_a) {
        var statusDescription = _a.statusDescription, totalPrice = _a.totalPrice, unitPrice = _a.unitPrice;
        if (statusDescription === 'Canceled') {
            return "$".concat(unitPrice === null || unitPrice === void 0 ? void 0 : unitPrice.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }));
        }
        if (totalPrice && totalPrice > 0) {
            return "$".concat(totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }));
        }
        return "FREE";
    };
    return (React.createElement(React.Fragment, null, (items === null || items === void 0 ? void 0 : items.length) > 0 ? (React.createElement("div", { className: "sui-grid sui-gap-2 sui-mt-4" },
        React.createElement(Typography, { weight: "bold", style: { fontWeight: 'bold' } }, "Parts & Services"),
        React.createElement("div", { className: "sui-grid sui-gap-2" }, items === null || items === void 0 ? void 0 : items.map(function (item, key) { return (React.createElement("span", { key: key, className: "sui-flex su-items-center sui-justify-between" },
            React.createElement(Typography, null, item.description),
            React.createElement(Typography, { color: item.statusDescription === 'Canceled' ||
                    ((item === null || item === void 0 ? void 0 : item.totalPrice) && (item === null || item === void 0 ? void 0 : item.totalPrice) > 0)
                    ? 'primary'
                    : 'success' }, priceFormatter(item)))); })))) : null));
};
